import { render, staticRenderFns } from "./FreeBet.vue?vue&type=template&id=09a013b7&"
import script from "./FreeBet.vue?vue&type=script&lang=js&"
export * from "./FreeBet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports